<template>
  <div class="c-comment-editor" ref="hook">
    <div class="c-comment-editor__block">
      <img
        src="https://images.unsplash.com/photo-1509967419530-da38b4704bc6?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D"
      />
      <textarea class="form-control" rows="1"></textarea>
      <!-- <button class="btn btn-primary">Save</button> -->
    </div>
    <span class="c-comment-editor__arrow" data-popper-arrow>
      <svg
        width="12"
        height="24"
        viewBox="0 0 12 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.00013 16C11.9998 20 12 24 12 24L11.9988 0C11.9988 0 11.999 4 3.99896 8L3.99834 8.00031C1.99959 9.0002 0.000633302 10.0002 0.000199326 12C0.000227553 14 2.00015 15 4.00003 15.9999L4.00013 16Z"
          fill-opacity="1"
        />
      </svg>
    </span>
  </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

export default {
  data: function () {
    return {
      active: false,
      currentNote: null,
      target: null,
      popper: null,
    };
  },
  watch: {
    active: {
      handler: function () {
        if (this.active) {
          this.show();
        } else {
          this.hide();
        }
      },
      immediate: true,
    },
  },
  computed: {
    popperOptions: function () {
      let placement = "top";
      return {
        //strategy: "fixed",
        placement: placement,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 24],
            },
          },
          {
            name: "arrow",
            options: {
              padding: 24,
            },
          },
          {
            name: "flip",
            enabled: true,
          },
          {
            name: "computeStyles",
            options: {
              adaptive: false,
            },
          },
          {
            name: "eventListeners",
            enabled: false,
          },
        ],
      };
    },
  },
  methods: {
    activate: function (note) {
      if (this.active) {
        this.currentNote = note;
        this.el = document.querySelector(
          `.c-reading-item[data-id="${this.currentNote.id}"]`
        );
        this.popper.state.elements.reference = this.el;
        this.update();
      } else {
        this.currentNote = note;
        this.el = document.querySelector(
          `.c-reading-item[data-id="${this.currentNote.id}"]`
        );
        this.active = true;
      }
    },
    show: function () {
      if (this.$refs.hook) {
        let options = this.popperOptions;
        this.popper = createPopper(this.el, this.$refs.hook, options);
      }
    },
    update: function () {
      console.log("update");
      console.log(this.el);
      this.popper.update();
    },
    hide: function () {},
  },
};
</script>

<style lang="scss">
.c-comment-editor {
  width: 420px;
  background-color: var(--g4);
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0 0.5px 3.6px rgba(0, 0, 0, 0.087),
    0 1.5px 10px rgba(0, 0, 0, 0.125), 0 3.6px 24.1px rgba(0, 0, 0, 0.163),
    0 12px 80px rgba(0, 0, 0, 0.25);

  &__block {
    display: flex;
    align-items: flex-start;
  }

  &__arrow {
    position: absolute;
    bottom: -17px;
    left: calc(50% - 6px);
    width: 12px;
    height: 24px;
    line-height: 1;

    svg {
      transform: rotate(-90deg);
    }

    path {
      fill: var(--g4);
    }
  }

  img {
    width: 32px;
    height: 32px;
    object-fit: cover;
    border-radius: 50%;
  }

  textarea {
    margin-left: 10px;
    flex-grow: 1;
    background-color: rgba(0, 0, 0, 0.4);

    @include scrollBars();
  }
}
</style>